import { defineComponent as r, ref as i, onMounted as c, h as l } from "vue";
function m(t) {
  if (document.querySelector(`script[src="${t}"]`))
    return;
  const e = document.createElement("script");
  e.src = t, e.async = !0, e.type = "module", document.head.appendChild(e);
}
const d = {
  loaded: !0,
  "comment:published": !0,
  "comment:edited": !0,
  "comment:deleted": !0,
  "comment:voted": !0,
  "comment:flagged": !0,
  reaction: !0,
  rating: !0,
  "auth:login:clicked": !0,
  "profile:clicked": !0
}, u = Object.keys(d);
function p(t, e, n) {
  m("https://talk.hyvor.com/embed/embed.js"), customElements.whenDefined("hyvor-talk-comments").then(() => {
    const s = document.createElement("hyvor-talk-comments");
    for (const [o, a] of Object.entries(t))
      a !== void 0 && (o === "settings" || o === "translations" ? s[o] = a : s.setAttribute(o, a));
    u.forEach((o) => {
      s.addEventListener(o, (a) => {
        n(o, a.detail);
      });
    }), e.innerHTML = "", e.appendChild(s);
  });
}
function g(t = {}, e = null) {
  customElements.whenDefined("hyvor-talk-comment-count").then(() => {
    window.hyvorTalkCommentCounts.load(t, e);
  });
}
function h(t) {
  m("https://talk.hyvor.com/embed/comment-counts.js"), t.loading !== "manual" && g();
}
const b = {
  websiteId: !0,
  pageId: !0,
  pageUrl: !0,
  pageTitle: !0,
  pageLanguage: !0,
  pageAuthor: !0,
  ssoUser: !0,
  ssoHash: !0,
  colors: !0,
  loading: !0,
  settings: !0,
  translations: !0
}, f = Object.keys(b), y = u, w = r((t, { emit: e }) => {
  const n = i(null);
  return c(() => {
    const s = {};
    for (const o in t) {
      const a = o.replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, "$1-$2").toLowerCase();
      s[a] = t[o];
    }
    n.value ? p(
      s,
      n.value,
      (o, a) => {
        e(o, a);
      }
    ) : console.log("oopzi", n);
  }), () => l("div", { ref: n });
}, {
  props: f,
  /**
   * There is no way to provide type safety to emit payloads (at least I don't know)
   */
  emits: y
}), C = {
  websiteId: !0,
  pageId: !0,
  mode: !0,
  language: !0,
  loading: !0
}, k = Object.keys(C), j = r((t) => {
  const e = {};
  for (const n in t) {
    const s = n.replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, "$1-$2").toLowerCase();
    e[s] = t[n];
  }
  return c(() => {
    h(e);
  }), () => l("hyvor-talk-comment-count", e);
}, {
  props: k
});
export {
  j as CommentCount,
  w as Comments,
  g as loadCommentCounts
};
